import { Loader2 } from "lucide-react";
import { useAuth } from "@/contexts/AuthContext";
import Login from "@/pages/Login";

/**
 * Renders the app only once /auth/me has answered.
 *
 * Deliberately swaps the tree in place instead of redirecting to a /login route:
 * the URL the user asked for stays in the address bar, so signing in lands them
 * on the deep link they followed rather than bouncing them to the dashboard.
 */
export function RequireAuth({ children }) {
  const { checking, isAuthenticated } = useAuth();

  if (checking) {
    return (
      <div
        className="min-h-screen flex items-center justify-center"
        style={{ backgroundColor: "var(--oim-bg)" }}
        data-testid="auth-checking"
      >
        <Loader2 className="w-5 h-5 animate-spin" style={{ color: "var(--oim-text-dim)" }} />
      </div>
    );
  }

  if (!isAuthenticated) return <Login />;

  return children;
}
